import Image from "next/image";
import style from "./QueueComponent.module.scss";
import LoaderIcon from "../../../public/remove_back/magic_bg/loader_magic_bg.svg";
import { Loading_ellipsis } from "../../loading";
import Time from "../../number";

function QueueComponent({ dictionary, queueInfo, isNotFreeUser = false }) {
	return (
		<div className={style.block} id="loading-block">
			<div className={style["color-block"]}>
				<div className={style["queue-message"]}>
					<span
						dangerouslySetInnerHTML={{
							__html: `${dictionary["Your request is sent to our server"].replace("X", `<b>${queueInfo.users}</b>`).slice(0, -2)}`,
						}}
					></span>
					<b>
						<Time time={queueInfo.time} />
					</b>
					.
				</div>
				{isNotFreeUser && (
					<div className={style.promo}>
						<Image src={"/remove_back/magic_bg/interior_promo/social_promo.png"} width={307} height={302} className={style.image} alt="Affiliate promo" />
						<p
							className={style["promo-text"]}
							dangerouslySetInnerHTML={{
								__html: `${
									dictionary["share_images_videos"].replace("100", "30") ||
									'Share images / videos with <span>#CreatedWithBgRem</span> hashtag and send us the link to <a href="mailto:support@bgrem.ai">support@bgrem.ai</a> - we will give you <span>30 credits</span> for free!'
								}`,
							}}
						/>
					</div>
				)}
			</div>
			<div className={style.loader}>
				<LoaderIcon className={style["loader-icon"]} />
				<div className={style["loader-text"]}>
					{dictionary["Processing"]}
					<Loading_ellipsis />
				</div>
			</div>
		</div>
	);
}

export default QueueComponent;
